import { makeAutoObservable } from "mobx";

import type { DocumentModel } from "@/models/DocumentModel";

class DevToolsStore {
  private create: { start: number; end: number; started: boolean } = {
    start: 0,
    end: 0,
    started: false,
  };

  private firstRender: { start: number; end: number; started: boolean } = {
    start: 0,
    end: 0,
    started: false,
  };

  doc: DocumentModel | null = null;

  outlineNodes = false;

  showPriorities = false;

  showExpressionBoundaries = true;

  constructor() {
    makeAutoObservable(this);
  }

  startCounter(counter: "create" | "firstRender") {
    this[counter].start = performance.now();
    this[counter].end = performance.now();
    this[counter].started = true;
  }

  endCounter(counter: "create" | "firstRender") {
    if (!this[counter].started) return;
    this[counter].end = performance.now();
    this[counter].started = false;
  }

  getTime(counter: "create" | "firstRender") {
    const delta = this[counter].end - this[counter].start;
    return delta ? `${delta.toFixed(2)}ms` : "-";
  }
}

export const devTools = new DevToolsStore();
